module.exports = __webpack_public_path__ + "static/media/Himpunan Mahasiswa Manajemen (Universitas Sumatera Utara).23ebf038.jpeg";